export const KEYCLOAK_TOKENS = 'keycloakTokens';
